import { Jersey } from '@/ui/components';
import MeetingNumber from './MeetingNumber';
import MeetingLabel from './MeetingLabel';

export interface PreviousMeetingsStatColumnProps {
  /** URL of the jersey image. Empty string shows the generic placeholder. */
  jerseySrc: string;
  /** Stat number displayed below the jersey. */
  number: number;
  /** Stat label displayed below the number. */
  label: string;
}

export default function PreviousMeetingsStatColumn({
  jerseySrc,
  number,
  label,
}: PreviousMeetingsStatColumnProps) {
  return (
    <div className="flex flex-col items-center w-[100px]">
      <Jersey size={50} jerseySrc={jerseySrc} withOverlay />
      <div className="relative z-10 flex flex-col items-center mt-[-12px] text-center w-full">
        <MeetingNumber value={number} />
        <MeetingLabel text={label} />
      </div>
    </div>
  );
}
